import { OUTLOOK_BK_INTRO, OUTLOOK_BK_SLUG } from '@/content/outlookBanking'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The fifteenth report with a designed page of its own, and the sixth Future
  // 2030 outlook — asked for on 2026-08-28 in the same words as the Manufacturing,
  // Consumer Goods, Retail and Pharmaceutical ones (*"referans alarak ilgili
  // sayfayı birebir tıpa tıp aynısını tasarla"*) with a four-part full-page
  // capture of the live page and all six of the images it carries. See
  // `content/outlookBanking.ts` and `pages/OutlookBanking.tsx`.
  ...outlook(
    OUTLOOK_BK_SLUG,
    'Banking',
    undefined,
    'future-2030-outlook-banking-cover',
    '6edec37a-adf2-4608-b120-ff10c87544ac-Digital Transformation Outlook - Banking Industry.pdf',
  ),
  // The hero's own two lines, joined into one paragraph — same as the five outlook
  // entries below, and for the same reason: this page draws its hero from
  // `OUTLOOK_BK_INTRO` directly, so `body` feeds exactly one thing, the meta
  // description `prerender.tsx` takes from `body[0]`.
  body: [`${OUTLOOK_BK_INTRO.lede} ${OUTLOOK_BK_INTRO.body}`],
  layout: 'banking-outlook',
  // Its own words, its cover, its file and the six images its bands draw, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `outlookBankingChecks()` carries that into
  // the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 25
